import React, { useReducer, useState } from 'react';
import Slider from 'rc-slider';
import cn from 'classnames';

import type { ISliderProps } from './SliderComponent.types';

//STYLES
import styles from '@UILayer/UILayer.scss';
import 'rc-slider/assets/index.css';

import { useAppSelector } from '@Managers/Redux/Hooks';
import { getGlobalStyles, getWCAMode } from '@Managers/Redux/AppState/AppState';

const DEFAULT_MIN: number = 0;
const DEFAULT_MAX: number = 1000;
const DEFAULT_STEP: number = 0.01;

//REDUX

const SliderComponent: React.FC<ISliderProps> = ({
    min = DEFAULT_MIN,
    max = DEFAULT_MAX,
    prefix,
    postfix,
    defaultValue = 250,
    label,
    changeComplete,
    handleChange,
    showValueBox = true,
    disabled = false
}) => {
    const [value, setValue] = useState<number>(defaultValue);
    const wcaMode = useAppSelector(getWCAMode); // <!
    const globalStyles = useAppSelector(getGlobalStyles);

    const railStyles: React.CSSProperties = {
        backgroundColor: '#242228'
    };

    const trackStyles: React.CSSProperties = {
        background: wcaMode ? '#fff' : '#37b74d'
    };

    const handleStyles: React.CSSProperties = {
        background: wcaMode ? '#fff' : '#37b74d',
        width: 'auto',
        height: '150%',
        border: '2px solid #121116',
        opacity: '1',
        aspectRatio: '1/1',
        margin: '0'
    };

    const change = (newValue: number | number[], handle: boolean = true) => {
        const newValueAsNumber: number = Array.isArray(newValue) ? newValue[0] : newValue;
        setValue(newValueAsNumber);
        if (handleChange) handleChange(newValueAsNumber);
    };

    const complete = () => {
        if (changeComplete) changeComplete(value);
    };

    return (
        <div className={cn(styles.slider, globalStyles.wcaMode)}>
            <Slider
                disabled={disabled}
                styles={{ track: trackStyles, handle: handleStyles, rail: railStyles }}
                min={min}
                max={max}
                defaultValue={defaultValue}
                onChange={(value) => change(value)}
                onChangeComplete={(value) => complete()}
                ariaValueTextFormatterForHandle={(value) => {
                    return `value: ${value}`;
                }}
                value={defaultValue}
            />

            {showValueBox && (
                <div className={styles.value_box}>
                    {prefix && <span>{prefix}</span>}
                    <span>{label ? label : value}</span>
                    {postfix && <span>{postfix}</span>}
                </div>
            )}
        </div>
    );
};

export default SliderComponent;
